"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyedSet = exports.KeyedSetBase = void 0;
var KeyedSetBase = /** @class */ (function () {
    function KeyedSetBase(indexer) {
        this.indexer = indexer;
    }
    Object.defineProperty(KeyedSetBase.prototype, "array", {
        get: function () {
            return this.list;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KeyedSetBase.prototype, "size", {
        get: function () {
            return this.list.length;
        },
        enumerable: false,
        configurable: true
    });
    KeyedSetBase.prototype.add = function (value) {
        var key = this.indexer(value);
        if (this.index.has(key)) {
            return false;
        }
        else {
            this.index.set(key, value);
            this.list.push(value);
            return true;
        }
    };
    KeyedSetBase.prototype.addAll = function () {
        var _this = this;
        var values = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            values[_i] = arguments[_i];
        }
        values.forEach(function (x) { return _this.add(x); });
    };
    KeyedSetBase.prototype.clear = function () {
        this.index.clear();
        this.list.splice(0, this.list.length);
    };
    KeyedSetBase.prototype.delete = function (key) {
        var value = this.get(key);
        if (value) {
            var i = this.list.indexOf(value);
            this.index.delete(key);
            this.list.splice(i, 1);
            return true;
        }
        else {
            return false;
        }
    };
    KeyedSetBase.prototype.remove = function (value) {
        return this.delete(this.indexer(value));
    };
    KeyedSetBase.prototype.removeAll = function (values) {
        var _this = this;
        values.forEach(function (x) { return _this.remove(x); });
    };
    KeyedSetBase.prototype.has = function (value) {
        var key = this.indexer(value);
        return !!this.index.has(key);
    };
    KeyedSetBase.prototype.get = function (key) {
        return this.index.get(key) || null;
    };
    KeyedSetBase.prototype.select = function (keys) {
        var _this = this;
        return keys.map(function (x) { return _this.get(x); }).filter(function (x) { return !!x; });
    };
    KeyedSetBase.prototype.first = function () {
        return this.list[0];
    };
    KeyedSetBase.prototype.last = function () {
        return this.list[this.list.length - 1];
    };
    KeyedSetBase.prototype.slice = function (start, end) {
        return this.list.slice(start, end);
    };
    KeyedSetBase.prototype.forEach = function (callback) {
        this.list.forEach(callback);
    };
    KeyedSetBase.prototype.filter = function (callback) {
        return this.list.filter(callback);
    };
    KeyedSetBase.prototype.find = function (callback) {
        return this.list.find(callback) || null;
    };
    KeyedSetBase.prototype.map = function (callback) {
        return this.list.map(callback);
    };
    KeyedSetBase.prototype.reduce = function (callback, initial) {
        return this.list.reduce(callback, initial);
    };
    KeyedSetBase.prototype.except = function (items) {
        return this.list.filter(function (x) { return !items.includes(x); });
    };
    KeyedSetBase.prototype[Symbol.iterator] = function () {
        return this.list[Symbol.iterator]();
    };
    return KeyedSetBase;
}());
exports.KeyedSetBase = KeyedSetBase;
var KeyedSet = /** @class */ (function (_super) {
    __extends(KeyedSet, _super);
    function KeyedSet() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.list = [];
        _this.index = new Map();
        return _this;
    }
    return KeyedSet;
}(KeyedSetBase));
exports.KeyedSet = KeyedSet;
